import React from "react";

const Name = () => {
  return (
    <div className="pb-4 sm:pb-0">
      <h1 className="font-extrabold text-3xl">
        Giovanni Arizola
        <span className="font-extrabold text-lg hidden sm:inline">
          , Developer
        </span>
      </h1>
      <span className="font-extrabold sm:hidden block text-center">
        Developer
      </span>
    </div>
  );
};

export default Name;
